import { useRouterState } from '../routing/useRouterState';

export const useVisibleDate = (initialDate: Date) => {
  const calendarDate = useRouterState({ key: 'eventDate' });
  const selectedDate = calendarDate && new Date(Number(calendarDate[0]));

  const isValidDate = (date: Date) => {
    return date && !isNaN(date.getTime());
  };

  return isValidDate(selectedDate) ? selectedDate : initialDate;
};
